import { useApi } from '@api/ApiProvider'
import type { MagicPlaceInput } from '@api/endpoints'
import { useI18n } from '@i18n/I18nProvider'
import { getAnonymousId } from '@lib/anonymous-id'
import { resizeImage } from '@lib/resize-image'
import { useMutation } from '@tanstack/react-query'

export type MagicPlaceDraft = Omit<MagicPlaceInput, 'anonymousId'>

// Nombre recortado y con los espacios repetidos juntados, como lo guarda el backend.
export const MAX_NAME = 120
export const cleanName = (name: string): string => name.trim().replace(/\s+/g, ' ')

// Proponer un lugar mágico (spec `magic-place-proposals`): reduce la foto en el navegador y
// añade el identificador anónimo, el mismo de los avisos, para saber qué viene de quién.
export const useProposeMagicPlace = () => {
	const api = useApi()
	const { locale } = useI18n()
	return useMutation({
		mutationFn: async (draft: MagicPlaceDraft) =>
			api.proposeMagicPlace(
				{
					name: cleanName(draft.name),
					photo: await resizeImage(draft.photo),
					location: draft.location,
					anonymousId: getAnonymousId(),
				},
				locale
			),
	})
}
